module.exports = __webpack_public_path__ + "img/picnic.7476be12.svg";